import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationStartupService } from './application-startup.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class RouteApplicationStartupResolveService {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.applicationStartUp.LoadApplication();
  }

  constructor(private applicationStartUp: ApplicationStartupService) {}
}
